module.exports = __webpack_public_path__ + "042f08373f0c662df7c87f2c24f37c11.jpg";